import { colors } from '../../colors';
var para = {
  messageColor: colors.metal
};
export default para;